import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import DownloadIcon from '@mui/icons-material/Download';
import { Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useState } from 'react';
import RightSidebarPaper from 'src/components/ui-component/form-component/right-side-bar/RightSidebarPaper';
import { useApplication } from 'src/context/ApplicationContext';
import { enumT } from 'src/utils/helper';
import { ANTRAG_TYP, ANTRAGS_FORMULAREN, ART_DES_ANTRAGS } from '../../../../lib/constants/constant';
import { DisplayDateTime } from '../../../../utils/formats';
import AnsprechPartnerKontakt from '../antrag-components/AnsprechPartnerKontakt';
import RightIconButton from '../antrag-components/RightIconButton';
import { DownloadAntragPDF } from '../DownloadAntragPDF';

// import Schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

/**
 * TODO: Refactor duplicated code with AbschlussAntragHerunterladen.tsx
 * Es gibt noch die gleiche Logik für ImagesPaths in AbschlussAntragHerunterladen.tsx
 * Das muss noch zusammengeführt werden.
 */
const ImagesPathsEmobFundE = [
	P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0009162530_FE_Ausgangssituation_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0178136770_reibung_Des_Vorhabens_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0139433634_sblick_Und_Verwertung_Bilder.path,
];
const ImagesPathsEmobInvest = [
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0095548994_est_Ausgangssituation_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0112109858_ionen_Elektrofahrzeug_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0193290210_nen_Ladeinfrastruktur_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0103379282_toff_Betankungsanlage_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0220424306_chreibung_Und_Vergabe_Bilder.path,
	P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0109936114_onstige_Informationen_Bilder.path,
];
const ImagesPathsLoewe = [
	// Ausgangssituation
	P.Projektbeschreibung_Loewe.schema.attributes.Ausgangssituation_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder.path,
	// Beschreibung des Vorhabens
	P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder.path,
	// Markt analyse
	P.Projektbeschreibung_Loewe.schema.attributes.Marktanalyse_Wettbewerbstechnologien_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Anwendungsgebiete_Und_Kundennutzen_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Markteintrittsstrategie_Markteinfuehrungserfolge_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Moegliche_Markteintrittsbarrieren_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Schutzrechte_Lizenzen_Zwischen_Verbundpartnern_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Unternehmensentwicklung_Erwartete_Arbeitsplatzeffekte_Bilder.path,
	// Wissenschaftliche Effekte
	P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.path,
	// Organisation
	P.Projektbeschreibung_Loewe.schema.attributes.Meilensteinplanung_Bilder.path,
	// Standort Effekte
	P.Projektbeschreibung_Loewe.schema.attributes.Aussendarstellung_Bilder.path,
	// Skizze
	P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder.path,
	P.Projektbeschreibung_Loewe.schema.attributes.Marktanalyse_Bilder.path,
];

const FoerderAntragRightSidebar: FC<{}> = () => {
	const { application, saveApplication, readOnly } = useApplication();
	const [showAPKontaktdaten, setShowAPKontaktdaten] = useState(false);

	const handleOpenDialog = () => {
		setShowAPKontaktdaten(true);
	};
	const handleCloseDialog = () => {
		setShowAPKontaktdaten(false);
	};

	const handleDownloadAntrag = async () => {
		const antragsFormular = get(application, P.Allgemein_Antragsformular.path);
		let ImagesPaths: any[] = [];
		if (antragsFormular === ANTRAGS_FORMULAREN.EmobFundE) {
			ImagesPaths = ImagesPathsEmobFundE;
		} else if (antragsFormular === ANTRAGS_FORMULAREN.EmobInvest) {
			ImagesPaths = ImagesPathsEmobInvest;
		} else if (antragsFormular === ANTRAGS_FORMULAREN.Loewe) {
			ImagesPaths = ImagesPathsLoewe;
		}
		await DownloadAntragPDF(application, readOnly, saveApplication, ImagesPaths);
	};

	const handleBeihilferelevanzDownload = async () => {
		// TODO: Implement Beihilferelevanz PDF download via template service
		console.log('Beihilferelevanz download requested from right sidebar');
	};

	const isAntrag = get(application, P.Allgemein_Typ.path, '') === ANTRAG_TYP.Antrag;
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;
	const formular =
		isAntrag ?
			isFormantrag ? get(application, P.Allgemein_Art_Des_Antrags.path, '')
			:	get(application, P.Allgemein_Typ.path, '')
		:	get(application, P.Allgemein_Typ.path, '');
	return (
		<>
			<AnsprechPartnerKontakt open={showAPKontaktdaten} onClose={handleCloseDialog} application={application} />
			<RightSidebarPaper>
				<span>
					<Typography variant='body1'>Online-Formular:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{formular}
					</Typography>
				</span>

				{get(application, P.Allgemein_Art_Des_Antrags.path) === ART_DES_ANTRAGS.AenderungsAntrag && (
					<span>
						<Typography variant='body1'>Art des Antrags:</Typography>
						<Typography fontWeight={500} variant='body1'>
							{enumT(get(application, P.Allgemein_Art_Des_Antrags.path, ''))}
						</Typography>
					</span>
				)}

				{get(application, P.Allgemein_Antragsformular.path, '') === ANTRAGS_FORMULAREN.Mobilitaetsplaene && (
					<span>
						<Typography variant='body1'>Gegenstand der Förderung:</Typography>
						<Typography fontWeight={500} variant='body1'>
							{enumT(
								get(
									application,
									P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0195191031_ng_Gegenstand_Der_Foerderung
										.path,
									'',
								),
							)}
						</Typography>
					</span>
				)}

				{get(application, P.Allgemein_Antragsformular.path, '') === ANTRAGS_FORMULAREN.Elektrobusse && (
					<span>
						<Typography variant='body1'>Gegenstand der Förderung:</Typography>
						<Typography fontWeight={500} variant='body1'>
							{(
								enumT(get(application, P.Projektbeschreibung_Elektrobusse.schema.attributes.Gegenstand_Der_Foerderung.path, '')).includes(
									'Nachrüstung',
								)
							) ?
								'Nachrüstung'
							:	'Beschaffung'}
						</Typography>
					</span>
				)}
				<span>
					<Typography variant='body1'>Status:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Antragstatus_Antragstatus.path, ''))}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Förderprogramm:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{enumT(get(application, P.Allgemein_Antragsformular.path, ''))}
					</Typography>
				</span>
				{get(application, P.Skizze.schema.attributes.Allgemein_Eingangsnummer.path) && (
					<span>
						<Typography variant='body1'>HA-Eingangsnummer Skizze:</Typography>
						<Typography fontWeight={500} variant='body1'>
							{get(application, P.Skizze.schema.attributes.Allgemein_Eingangsnummer.path, 'ausstehend')}
						</Typography>
					</span>
				)}
				<span>
					<Typography variant='body1'>
						{get(application, P.Allgemein_Typ.path, '') === ANTRAG_TYP.Antrag ? 'HA-Eingangsnummer Antrag:' : 'HA-Eingangsnummer:'}
					</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Allgemein_Eingangsnummer.path, 'ausstehend')}
					</Typography>
				</span>
				{get(application, P.Allgemein_Typ.path, '') === 'Antrag' && (
					<span>
						<Typography variant='body1'>Referenz-Nummer:</Typography>
						<Typography fontWeight={500} variant='body1'>
							{get(application, P.Allgemein_Referenz_Nr.path, 'ausstehend')}
						</Typography>
					</span>
				)}
				<span>
					<Typography variant='body1'>HA-Projektnummer:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{get(application, P.Allgemein_HA_Projekt_Nr.path, 'ausstehend')}
					</Typography>
				</span>
				<span>
					<Typography variant='body1'>Erstellt am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, 'attributes.createdAt'))}
					</Typography>
				</span>

				<span>
					<Typography variant='body1'>Zuletzt geändert am:</Typography>
					<Typography fontWeight={500} variant='body1'>
						{DisplayDateTime(get(application, P.Allgemein_Geaendert_Durch_Antragsteller.path, ''))}
					</Typography>
				</span>
			</RightSidebarPaper>
			<Stack direction={'row'} spacing={3} sx={{ mt: '2rem' }}>
				{get(application, P.Allgemein_Projekttitel.path, '') && get(application, P.Allgemein_Kurzwort.path, '') ?
					<RightIconButton onClick={handleDownloadAntrag} icon={<DownloadIcon />} tooltipTitle='Aktuellen Status herunterladen' />
				:	null}
				{get(application, P.Beihilferelevanz_Selbsterklaerung.path, []).length > 0 && (
					<RightIconButton
						onClick={handleBeihilferelevanzDownload}
						icon={<DownloadIcon />}
						tooltipTitle='Beihilferelevanz-Selbsterklärung herunterladen'
					/>
				)}
				<RightIconButton onClick={handleOpenDialog} icon={<AddIcCallIcon />} tooltipTitle='Kontaktinformationen der Ansprechpartner' />
			</Stack>
		</>
	);
};
export default FoerderAntragRightSidebar;
